import {_} from 'lodash';
import * as ko from "knockout";
import PromiseRequest from "../../../../req/PromiseRequest";
import {
    IAuthenticationType,
    IButton,
    IFormTemplate,
    IFormTemplatePage,
    IMessageData,
    IObjectData,
    IRouteDefinitionParams
} from '../../../../index';
import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";
import {Permission, SPINNER, WIN_NAME_IFRAME, EHUB_IDS} from "../../../../constants";
import {createErrorMessage, getEadmRole, isBit} from "../../../../util/misc";
import {global} from "../../../../appContext";
import {getEHubAssetUrl} from "../../../../ehub/assetVersion";
import {nsFormTemplate} from "../nsFormTemplate";
import {IRequestObject} from "../../../../req/index";
import {nsRoute} from "../../../../util/route";
import {ButtonManager} from "../../../../util/ButtonManager";
import {getBackButton, getRouteButton, setRouteHash} from "../../../../constants/RouteDefinitions";
import {REQUEST_MESSAGE} from "../../../../constants/Language";
import trashDialog = nsFormTemplate.trashDialog;
import openFormDialog = nsFormTemplate.openFormDialog;
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import ButtonOrder = nsRoute.ButtonOrder;
import detailsHtml from './details.html?raw';

export let template = detailsHtml;

type T = IFormTemplate;

interface ICustomFormTemplatePage extends IFormTemplatePage {
    showHtml: KnockoutObservable<boolean>
}

export class viewModel extends ParsedRouteDataDecorator {
    private data!: T;
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private readonly reqGetAuthenticationTypes: PromiseRequest = global.getPromiseRequest('getauthenticationtypes');
    private readonly reqDeleteFormTemplate!: IRequestObject;
    private readonly heading: KnockoutObservable<string | null> = ko.observable(null);
    private static readonly Heading = 'Skjemamal';
    private pages!: ICustomFormTemplatePage[];
    private authenticationTypes!: IAuthenticationType[];
    private selectedManualUser: KnockoutObservable<IObjectData | null> = ko.observable(null);
    private readonly headerButtons: ButtonManager = new ButtonManager()
    private readonly pageButtons: ButtonManager = new ButtonManager()

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.kosub.subscribe(global.login.selectedOrganization, () => this.init());
        this.kosub.subscribe(this.selectedManualUser, (selectedObject: IObjectData | null) => {
            if (!selectedObject) {
                return;
            }
            window.open(`/win.html#/formview/${this.data.companyid}/${this.__id}/${selectedObject.id}/1`, WIN_NAME_IFRAME);
        });
        this.init();
    }

    /** Injects eHub CSS for this read view, cache-busted via shared build.json ver/t. */
    private async init_css(): Promise<void> {
        if (document.getElementById(EHUB_IDS.css_id)) {
            return
        }
        const el = document.getElementsByTagName('head')[0]
        if (!el) {
            return
        }
        const css = document.createElement('link')
        css.id = EHUB_IDS.css_id
        css.rel = 'stylesheet'
        css.href = await getEHubAssetUrl('index.css')
        el.append(css)
    }

    private init() {
        void this.init_css()

        this.heading(viewModel.Heading);
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        Promise.resolve()
            .then(() => {
                return this.__requestRouteData!
                    .request()
                    .then((data: T[]) => {
                        const template = data[0];
                        if (!template) {
                            return;
                        }
                        this.data = template;
                        this.pages = _.sortBy(this.data.pages, 'order').map((o: IFormTemplatePage) => _.defaults({showHtml: ko.observable(false)}, o));
                        let btn: IButton;
                        btn = {
                            onClick: () => openFormDialog(this.data),
                            icon: 'fa-link',
                            label: 'Open subject|s:((form template|ac))',
                            order: ButtonOrder.PREVIEW,
                            validator: () => getEadmRole() >= Permission.CompanyAdmin,
                        };
                        this.headerButtons.add(btn)
                        this.pageButtons.add(btn)
                        btn = {
                            onClick: () => this.onDeleteClick(),
                            cssClass: 'danger btn-ready-calm',
                            icon: 'fa-trash-alt',
                            label: 'Delete subject|s:((form template|ac))',
                            order: ButtonOrder.DELETE,
                            validator: () => getEadmRole() >= Permission.CompanyAdmin,
                        };
                        this.headerButtons.add(btn)
                        this.pageButtons.add(btn)
                        this.pageButtons.add(getBackButton())
                        if (this.__routeDef.edit) {
                            btn = getRouteButton(this.__routeDef.edit, {order: ButtonOrder.EDIT})
                            this.pageButtons.add(btn)
                        }
                    });
            })
            .then(() => {
                return this.reqGetAuthenticationTypes
                    .request()
                    .then((data: IAuthenticationType[]) => {
                        this.authenticationTypes = _.sortBy(data.filter((a: IAuthenticationType) => isBit(a.flag, this.data.authenticationtypes)), (a: IAuthenticationType) => a.name.toLowerCase());
                    });
            })
            .then(() => {
                this.heading(`${viewModel.Heading} [${this.data.name}]`);
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            });
    }

    private onDeleteClick() {
        trashDialog(this.data, (reqObj: IRequestObject) => {
            this.isReady(false);
            this.messageData({message: `Sletter skjemamal... ${SPINNER}`})
            reqObj.request.then(() => {
                setRouteHash('formtemplatesearch');
                global.cacheManager.removeCache('getehubprocess')
                global.cacheManager.removeCache('getformtemplate')
                global.cacheManager.removeCache('getruleset')
                global.cacheManager.removeCache('searchformtemplate')
                global.cacheManager.removeCache('searchruleset')
            })
        })
    }

    override dispose() {
        this.kosub.unsuscribeAll();
        this.reqGetAuthenticationTypes.abort();
        this.reqDeleteFormTemplate?.promise.abort();
    }
}
